import {
    MaximizeProfitabilityWidget,
    StreamlineOperationsWidget,
    DataDrivenDecisionsWidget,
} from './AtomizeCampaignWidget';

// Weight has to be triple as the data security so that there is
// a 50% chance of either Atomize or Data Security tiles to appear
const ATOMIZECAMPAIGN_WEIGHT = 60;

export const useDashboardAtomizeCampaignWidgets = () => [
    {
        component: <MaximizeProfitabilityWidget />,
        weight: ATOMIZECAMPAIGN_WEIGHT,
    },
    {
        component: <StreamlineOperationsWidget />,
        weight: ATOMIZECAMPAIGN_WEIGHT,
    },
    {
        component: <DataDrivenDecisionsWidget />,
        weight: ATOMIZECAMPAIGN_WEIGHT,
    },
];
